module.exports = __webpack_public_path__ + "static/hero-h264.140242c3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/hero-h264.mp4
// module id = 3710
// module chunks = 35783957827783